import { FC, useState } from 'react'
import Row from '@components/row'
import Button from '@components/button'
import AppointmentCancel from '@commons/popups/cancel'
import Alert from '@commons/popups/alert'
import useAppointmentActions from '@hooks/useAppointmentActions'
import { Appointment } from '@apis'
import { useSelector } from 'react-redux'
import { Helper } from '@utils'
interface AppointmentActionsProps {
  id: number
  status: string
  appointmentType: String
}
const AppointmentActions: FC<AppointmentActionsProps> = ({
  id,
  status,
  appointmentType,
}) => {
  const { data: user } = useSelector((state: any) => state.user)
  const {
    alertInfo,
    visible,
    loading: alertLoading,
    handleClickBtn,
    handleClickYes,
    handleClose,
  } = useAppointmentActions({
    selector: 'consultAppointment',
  })

  const [startVisible, setStartVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const handleStartConversation = async () => {
    setStartVisible(true)
  }

  const handleStartConfirm = async () => {
    setLoading(true)
    await Appointment.updateStatus({
      data: {
        status: 'On Going',
      },
      id,
      state: 'consultAppointment',
      action: 'update',
    })
      .then((resp) => {
        if (appointmentType == 'At Clinic') {
        } else {
          handleClose()
          Helper.saveCallSession({
            callType: 'audio',
            receiver: {
              id: resp?.patient?.id,
              name: resp?.patient?.name,
              avatar: resp?.patient?.avatar,
            },
            type: 'outgoing',
            conversationId: resp?.conversationId,
            callSenderId: user?.id,
            callReceiverId: resp?.patient?.id,
          })
          window.open(`/${user?.role}/call`, '_blank')
        }
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <>
      <Row justifyContent="flex-end" colGap={20} onClick={handleClickBtn}>
        {status == 'Pending' && (
          <>
            <Button
              title="Cancel"
              outline
              bg={'danger'}
              height={45}
              data-cross-type={`cancel-${id}`}
            />
            <Button title="Confirm" height={45} data-cross-type="confirm" />
          </>
        )}
        {status == 'Confirmed' && (
          <>
            <Button
              title="Cancel"
              outline
              bg={'danger'}
              height={45}
              data-cross-type={`cancel-${id}`}
            />
            {user?.role == 'doctor' && (
              <Button
                title="Start Consultation"
                height={45}
                onClick={handleStartConversation}
              />
            )}
          </>
        )}
        {status == 'On Going' && (
          <Button
            title="Mark as Completed"
            height={45}
            data-cross-type={`complete-${id}`}
          />
        )}
        {/* {status == 'Completed' && (
          <Button
            title="Schedule Follow Up"
            height={45}
            data-cross-type={`followup-${id}`}
          />
        )} */}
      </Row>
      {!!visible && alertInfo?.type == 'cancel' && (
        <AppointmentCancel id={id} visible={visible} onClose={handleClose} />
      )}
      {!!visible && alertInfo?.type == 'confirm' && (
        <Alert
          title={'Confirmed Request'}
          visible={visible}
          description="Are you sure you want to confirmed request ?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}

      {!!visible && alertInfo?.type == 'complete' && (
        <Alert
          title={'Completed Request'}
          visible={visible}
          description="Are you sure you want to completed appointment ?"
          onClickOk={handleClickYes}
          onClickClose={handleClose}
          loading={alertLoading}
        />
      )}

      {!!startVisible && (
        <Alert
          title="Start Consultation"
          visible={startVisible}
          description="Are you sure you want to start conversation ?"
          onClickOk={handleStartConfirm}
          onClickClose={() => {
            setStartVisible(false)
          }}
          loading={loading}
        />
      )}
    </>
  )
}

export default AppointmentActions
